// extracted by mini-css-extract-plugin
module.exports = {"sizeListSmall":"ConfirmRenewalAndBilling_sizeListSmall__26pQA","sizeU":"ConfirmRenewalAndBilling_sizeU__vp94-"};